export const usuariosRoutesMap = {
  gestion: {
    path: '/usuarios/gestion',
    name: 'Gestión de Usuarios',
  },
  nuevo: {
    path: '/usuarios/nuevo',
    name: 'Nuevo Usuario',
  },
  modificar: {
    path: `/usuarios/modificar`,
    name: 'Actualizar Registro',
  },
}
